<template>
  <div class="creation-demand-step-typical-schedule">
    <Schedule
      :hide-icon="$q.screen.lt.md"
      :start-time="typicalSchedule[ICreationStepPlanningDay.start]"
      :end-time="typicalSchedule[ICreationStepPlanningDay.end]"
      :break-time-duration="typicalSchedule[ICreationStepPlanningDay.break]"
      :schedule-options="scheduleOptions"
      @select-start="setSchedule({ property: ICreationStepPlanningDay.start, value: $event })"
      @select-end="setSchedule({ property: ICreationStepPlanningDay.end, value: $event })"
      @select-break-duration="setSchedule({ property: ICreationStepPlanningDay.break, value: $event })"
    />
  </div>
</template>

<script>
  import { DatesHelpers, ScheduleHelpers } from "@core/helpers";
  import { ICreationStepPlanningDay } from "@core/models";

  import Schedule from "@core/components/forms/Schedule.component.vue";

  export default {
    components: {
      Schedule,
    },
    props: {
      firstShift: {
        type: Object,
        default: () => ({}),
      },
      typicalSchedule: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["setSchedule"],
    computed: {
      isToday() {
        return DatesHelpers.dateIsToday(this.firstShift[ICreationStepPlanningDay.date]);
      },
    },
    created() {
      this.ICreationStepPlanningDay = ICreationStepPlanningDay;
      this.setScheduleOptions();
    },
    methods: {
      setSchedule({ property, value }) {
        this.$emit("setSchedule", { property, value });
      },
      setScheduleOptions() {
        this.scheduleOptions = ScheduleHelpers.getFullScheduleOptions({
          undefined,
          stampText: this.$t("CORE.COMPONENTS.SCHEDULE.@DAY_PLUS_ONE"),
          nullBreakLabel: this.$t("CORE.COMPONENTS.SCHEDULE.@BREAK_NONE"),
        });
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-step-typical-schedule {
    width: 305px;
    @media screen and (max-width: $breakpoint-sm-max) {
      width: 260px;
    }
  }
</style>
